import React, { useEffect, useState, useMemo, useRef } from 'react';
import { FaFilePdf, FaWhatsapp } from 'react-icons/fa';
import AnexosConvocatoria from '../components/AnexosConvocatoria';
import BotonDocumentos from '../components/BotonDocumentos';
import { enlaceDeBases, buildConvocatoriaMessage, whatsappShareUrl } from '../services/convocatoriaShare';
import {
  Label,
  Input,
  Card,
  CardBody,
  Spinner,
  Button,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

// Importar cliente de Supabase desde el archivo supabaseClient
import './Seacenuevos.scss';
import './seacenuevos9a.scss';
import {
  FiRefreshCw, FiSearch, FiX, FiChevronLeft,
  FiChevronRight, FiCheck, FiCalendar,
  FiCopy, FiCornerDownRight, FiExternalLink,
  FiClock, FiInbox, FiHome, FiFilePlus
} from 'react-icons/fi';
import { CalendarCheck, CalendarX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase, formatDateFromSupabase } from '../services/supabaseClient';

// Ordenamientos ofrecidos en el selector "Ordenar por"
const ORDEN_OPCIONES = [
  { id: 'cierre_asc', label: 'Cierre más próximo', key: 'fecha_fin_participantes', dir: 'asc' },
  { id: 'cierre_desc', label: 'Cierre más lejano', key: 'fecha_fin_participantes', dir: 'desc' },
  { id: 'conv_desc', label: 'Convocatoria reciente', key: 'fecha_convocatoria', dir: 'desc' },
  { id: 'entidad_asc', label: 'Entidad (A–Z)', key: 'entidad', dir: 'asc' }
];

// ✅ MEJORA: Configuración centralizada
const CONFIG = {
  CACHE_DURATION: 60 * 60 * 1000, // 60 minutos
  BATCH_SIZE: 500,
  IS_DEV: process.env.NODE_ENV === 'development'
};

// Cache global para almacenar los datos
let globalSEACENuevosCache = {
  data: null,
  totalRecords: 0,
  timestamp: null,
  isLoading: false
};

// ✅ MEJORA: Funciones de logging condicional
const devLog = (...args) => {
  if (CONFIG.IS_DEV) console.log(...args);
};

const devError = (...args) => {
  if (CONFIG.IS_DEV) console.error(...args);
};

const SEACENuevos = ({ user }) => {
  const navigate = useNavigate();

  // Estados principales
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [currentBatch, setCurrentBatch] = useState(0);
  const [totalBatches, setTotalBatches] = useState(0);
  
  // ✅ MEJORA: Estados adicionales para mejor UX
  const [toastMessage, setToastMessage] = useState(null);
  const [cacheValid, setCacheValid] = useState(false);
  
  // Estados para el sistema de revisión
  const [processosRevisados, setProcessosRevisados] = useState(new Set());
  const [loadingReviewed, setLoadingReviewed] = useState(false);
const [filtroEstadoRevision, setFiltroEstadoRevision] = useState('todos'); // 'todos', 'pendientes', 'revisados'
  
  // Estados para filtros
  const [entidadesSeleccionadas, setEntidadesSeleccionadas] = useState([]);
  const [filtroDescripcion, setFiltroDescripcion] = useState('');
  const [filtroTipoProceso, setFiltroTipoProceso] = useState('');
  const [filtroNomenclatura, setFiltroNomenclatura] = useState('');
  const [filtroObjeto, setFiltroObjeto] = useState('');
  const [filtroDepartamento, setFiltroDepartamento] = useState('');
  const [filtroProvincia, setFiltroProvincia] = useState('');
  const [filtroDistrito, setFiltroDistrito] = useState(''); // Nuevo filtro para distrito

  // Estados para dropdowns
  const [dropdownEntidad, setDropdownEntidad] = useState(false);
  const [searchEntidad, setSearchEntidad] = useState('');
  
  // Estados para ordenamiento y modal
  const [sortConfig, setSortConfig] = useState({ key: 'fecha_fin_participantes', direction: 'asc' });
  const [selectedProcess, setSelectedProcess] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  
  // Estados para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Reducido para móvil
  
  // Estados para tooltips de descripción
  const [hoveredDescription, setHoveredDescription] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  
  // Estados para vista móvil
  const [isMobile, setIsMobile] = useState(false);
  const [copiedKey, setCopiedKey] = useState(null);
  const [copiedModal, setCopiedModal] = useState(null);

  // 9a — búsqueda global + panel lateral de detalle
  const [busqueda, setBusqueda] = useState('');
  const [panelIndex, setPanelIndex] = useState(null); // índice en dataFiltrada mostrado en el panel lateral
  
  // Referencias para dropdowns
  const dropdownEntidadRef = useRef(null);
  const hasInitialized = useRef(false);
// Agrega estos console.log al inicio del componente, después de los estados
devLog('=== DEBUG INICIAL ===');
devLog('User prop:', user);
devLog('User ID:', user?.id);
devLog('Loading reviewed:', loadingReviewed);

  // ✅ MEJORA: Función para mostrar notificaciones toast
  const showToast = (message, type = 'info') => {
    setToastMessage({ message, type });
    setTimeout(() => setToastMessage(null), 3000);
  };

  // Detectar si es móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
const loadUserReviewedProcesses = async (userEmail) => {
  if (!userEmail) {
    devLog('❌ No hay email de usuario');
    return;
  }
  
  try {
    setLoadingReviewed(true);
    devLog('🔄 Cargando procesos revisados para:', userEmail);
    
    // ✅ MEJORA: Usar email y filtrar por fuente
    const { data, error} = await supabase
      .from('user_reviewed_processes')
      .select('process_id')
      .eq('user_id', userEmail)
      .eq('fuente', 'SEACE'); // ✅ Filtrar por fuente

    if (error) throw error;

    const reviewedIds = new Set(data.map(item => item.process_id));
    setProcessosRevisados(reviewedIds);
    
  } catch (error) {
    devError('Error cargando procesos revisados:', error);
  } finally {
    setLoadingReviewed(false);
  }
};
const toggleProcessReviewed = async (process, userEmail) => {
  devLog('=== TOGGLE PROCESS ===');
  devLog('Process:', process.nomenclatura);
  devLog('User email:', userEmail);
  
  if (!userEmail) {
    devError('❌ No userEmail en toggle');
    return;
  }
  
  try {
    const processId = `${process.nomenclatura}-${process.descripcion_proceso}`;
    devLog('Process ID generado:', processId);
    
    const isCurrentlyReviewed = processosRevisados.has(processId);
    devLog('Está actualmente revisado:', isCurrentlyReviewed);
    
    if (isCurrentlyReviewed) {
      devLog('🗑️ Removiendo de revisados...');
      const { error } = await supabase
        .from('user_reviewed_processes')
        .delete()
        .eq('user_id', userEmail)
        .eq('process_id', processId)
        .eq('fuente', 'SEACE'); // ✅ Filtrar por fuente

      if (error) {
        devError('❌ Error eliminando:', error);
        throw error;
      }
      
      devLog('✅ Eliminado de DB');
      setProcessosRevisados(prev => {
        const newSet = new Set(prev);
        newSet.delete(processId);
        devLog('✅ Estado actualizado - removido');
        return newSet;
      });
      
      showToast('❌ Proceso marcado como pendiente', 'warning');
      
    } else {
      devLog('➕ Agregando a revisados...');
      const { error } = await supabase
        .from('user_reviewed_processes')
        .insert({
          user_id: userEmail,
          process_id: processId,
          nomenclatura: process.nomenclatura,
          fuente: 'SEACE' // ✅ Agregar fuente
        });

      if (error) {
        devError('❌ Error insertando:', error);
        throw error;
      }
      
      devLog('✅ Insertado en DB:', data);
      setProcessosRevisados(prev => {
        const newSet = new Set([...prev, processId]);
        devLog('✅ Estado actualizado - agregado');
        return newSet;
      });
    }
    
  } catch (error) {
    devError('❌ Error en toggle:', error);
    showToast(`Error: ${error.message}`, 'danger');
  }
};

  // Función para verificar si un proceso está revisado
  const isProcessReviewed = (process) => {
    const processId = `${process.nomenclatura}-${process.descripcion_proceso}`;
    return processosRevisados.has(processId);
  };

  // Función para marcar todos los procesos como revisados
  const markAllAsReviewed = async () => {
    if (!user?.email) return;
    
    const procesosNoRevisados = dataAgrupada.filter(proceso => !isProcessReviewed(proceso));
    
    for (const proceso of procesosNoRevisados) {
      await toggleProcessReviewed(proceso, user.email);
    }
  };

  // Función para verificar si el cache es válido
// Función para verificar si el cache es válido
const isCacheValid = () => {
  if (!globalSEACENuevosCache.data || !globalSEACENuevosCache.timestamp) {
    setCacheValid(false);
    return false;
  }
  const now = Date.now();
  const isValid = (now - globalSEACENuevosCache.timestamp) < CONFIG.CACHE_DURATION; // ✅ CORREGIDO
  setCacheValid(isValid);
  return isValid;
};

  // Función para cargar desde cache o API
  const loadDataIfNeeded = async () => {
    if (isCacheValid() && !globalSEACENuevosCache.isLoading) {
      devLog('✅ Usando datos SEACE Nuevos desde cache', {
        registros: globalSEACENuevosCache.data.length,
        totalRecords: globalSEACENuevosCache.totalRecords
      });
      setData(globalSEACENuevosCache.data);
      setTotalRecords(globalSEACENuevosCache.totalRecords);
      setDataLoaded(true);
      return;
    }

    if (globalSEACENuevosCache.isLoading) {
      devLog('⏳ Datos SEACE Nuevos ya se están cargando...');
      if (globalSEACENuevosCache.data) {
        setData(globalSEACENuevosCache.data);
        setTotalRecords(globalSEACENuevosCache.totalRecords);
        setDataLoaded(true);
      }
      return;
    }

    await loadData();
  };

  // Efectos
useEffect(() => {
  if (!hasInitialized.current) {
    hasInitialized.current = true;
    loadDataIfNeeded();
    if (user?.email) { // ✅ MEJORA: Usar user.email
      loadUserReviewedProcesses(user.email);
    }
  }
}, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownEntidadRef.current && !dropdownEntidadRef.current.contains(event.target)) {
        setDropdownEntidad(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Función para obtener el conteo total de registros
  const getTotalCount = async () => {
    try {
      const { count, error } = await supabase
        .from('seace_news')
        .select('*', { count: 'exact', head: true });

      if (error) throw error;
      devLog(`📊 Total de registros en la tabla seace_news: ${count || 0}`);
      return count || 0;
    } catch (error) {
      devError('Error al obtener conteo total:', error);
      return 0;
    }
  };

  // Función para cargar datos en lotes
  const loadAllDataInBatches = async (totalCount) => {
    const allData = [];
    const batches = Math.ceil(totalCount / CONFIG.BATCH_SIZE);
    setTotalBatches(batches);
    
    devLog(`📊 Iniciando carga de ${totalCount} registros en ${batches} lotes de ${CONFIG.BATCH_SIZE}`);

    for (let i = 0; i < batches; i++) {
      const start = i * CONFIG.BATCH_SIZE;
      const end = Math.min(start + CONFIG.BATCH_SIZE - 1, totalCount - 1);
      
      setCurrentBatch(i + 1);
      devLog(`🔄 Cargando lote ${i + 1}/${batches} (registros ${start} a ${end})`);
      
      try {
        const { data: batchData, error } = await supabase
          .from('seace_news')
          .select('*')
          .range(start, end)
          .order('created_at', { ascending: false });

        if (error) {
          devError(`❌ Error en lote ${i + 1}:`, error);
          throw error;
        }
        
        if (batchData && batchData.length > 0) {
          allData.push(...batchData);
          devLog(`✅ Lote ${i + 1} cargado: ${batchData.length} registros (Total acumulado: ${allData.length})`);
        } else {
          console.warn(`⚠️ Lote ${i + 1} vacío`);
        }
        
        const progress = Math.round(((i + 1) / batches) * 100);
        setLoadingProgress(progress);
        
        if (i < batches - 1) {
          await new Promise(resolve => setTimeout(resolve, 50));
        }
        
      } catch (error) {
        devError(`❌ Error crítico en lote ${i + 1}:`, error);
        throw error;
      }
    }

    devLog(`✅ Carga completa: ${allData.length} registros de ${totalCount} esperados`);
    return allData;
  };

  // Función de carga de datos
  const loadData = async (forceRefresh = false) => {
    if (globalSEACENuevosCache.isLoading && !forceRefresh) {
      devLog('⏸️ Carga SEACE Nuevos ya en progreso, saltando...');
      return;
    }

    setLoading(true);
    setRefreshing(true);
    setError(null);
    setLoadingProgress(0);
    setCurrentBatch(0);
    setTotalBatches(0);
    globalSEACENuevosCache.isLoading = true;

    try {
      devLog('🔄 Iniciando carga completa de datos SEACE Nuevos...');
      
      const totalCount = await getTotalCount();
      
      if (totalCount === 0) {
        devLog('📭 No hay registros en la tabla seace_news');
        setData([]);
        setTotalRecords(0);
        setDataLoaded(true);
        showToast('No hay registros disponibles', 'warning');
        return;
      }

      const allData = await loadAllDataInBatches(totalCount);
      
      if (allData.length !== totalCount) {
        console.warn(`⚠️ Discrepancia en datos: esperados ${totalCount}, obtenidos ${allData.length}`);
      }
      
      devLog(`✅ Datos SEACE Nuevos cargados exitosamente: ${allData.length} registros`);
      
      globalSEACENuevosCache.data = allData;
      globalSEACENuevosCache.totalRecords = allData.length;
      globalSEACENuevosCache.timestamp = Date.now();
      
      setData(allData);
      setTotalRecords(allData.length);
      setDataLoaded(true);
      
      showToast(`✅ ${allData.length.toLocaleString()} procesos cargados`, 'success');
      
    } catch (error) {
      devError('❌ Error al cargar datos SEACE Nuevos:', error);
      setError(`Error al cargar los datos: ${error.message || 'Error desconocido'}. Por favor, intente nuevamente.`);
      showToast('Error al cargar los datos', 'danger');
    } finally {
      setLoading(false);
      setRefreshing(false);
      setLoadingProgress(100);
      setCurrentBatch(0);
      setTotalBatches(0);
      globalSEACENuevosCache.isLoading = false;
    }
  };

  // Función para refrescar datos manualmente
  const refreshData = () => {
    devLog('🔄 Refrescando datos SEACE Nuevos manualmente...');
    globalSEACENuevosCache.data = null;
    globalSEACENuevosCache.timestamp = null;
    loadData(true);
  };

  // ✅ MEJORA: Función para limpiar todos los filtros
  const clearAllFilters = () => {
    setBusqueda('');
    setEntidadesSeleccionadas([]);
    setFiltroDescripcion('');
    setFiltroTipoProceso('');
    setFiltroNomenclatura('');
    setFiltroObjeto('');
    setFiltroDepartamento('');
    setFiltroProvincia('');
    setFiltroDistrito('');
    setFiltroEstadoRevision('todos');
    setSearchEntidad('');
    setCurrentPage(1);
    showToast('Filtros limpiados', 'info');
  };


  // Función para agrupar datos por nomenclatura y descripción_proceso
  const dataAgrupada = useMemo(() => {
    devLog(`🔄 Agrupando ${data.length} registros nuevos...`);
    const grupos = new Map();
    
    data.forEach((item, index) => {
      const clave = `${item.id_procedimiento}`;
      
      if (!grupos.has(clave)) {
        grupos.set(clave, {
          created_at: item.created_at,
          entidad: item.entidad,
          tipo_proceso: item.tipo_proceso,
          num_proceso: item.num_proceso,
          nomenclatura: item.nomenclatura,
          departamento: item.departamento,
          provincia: item.provincia,
          distrito: item.distrito,
          objet: item.objeto || item.objet,
          moneda: item.moneda,
          fecha_convocatoria: item.fecha_convocatoria,
          fecha_presentacion_propuestas: item.fecha_presentacion_propuestas,
          descripcion_proceso: item.descripcion_proceso,
          fecha_inicio_participantes: item.fecha_inicio_participantes,
          fecha_fin_participantes: item.fecha_fin_participantes,
          items: [],
          url_doc: item.url_doc,
          url_anexos: item.url_anexos,
          total_items: 0,
          detalle_items_concat: ''
        });
      }
      
      const grupo = grupos.get(clave);
      
      if (item.detalle_item) {
        grupo.items.push({
          id_procedimiento: item.id_procedimiento,
          detalle_item: item.detalle_item,
          created_at: item.created_at,
          cantItem: item.cantItem,
          detCubso: item.detCubso,
          detUnidadMedida: item.detUnidadMedida
        });
      }
      
      grupo.total_items = grupo.items.length;
      grupo.detalle_items_concat = grupo.items
        .map(item => item.detalle_item)
        .filter(Boolean)
        .join('; ');
    });
    
    const resultado = Array.from(grupos.values());
    devLog(`✅ Agrupación completa: ${data.length} registros → ${resultado.length} procesos únicos nuevos`);
    return resultado;
  }, [data]);

  // Obtener valores únicos para filtros
  const entidadesUnicas = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.entidad).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const tiposProcesoUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.tipo_proceso).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const objetosUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.objet).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const departamentosUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.departamento).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const provinciasUnicas = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.provincia).filter(Boolean))).sort();
  }, [dataAgrupada]);

  // Nuevo: obtener distritos únicos
  const distritosUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.distrito).filter(Boolean))).sort();
  }, [dataAgrupada]);

  // Filtrar opciones basado en búsqueda
  const entidadesFiltradas = useMemo(() => {
    if (!searchEntidad.trim()) return entidadesUnicas;
    return entidadesUnicas.filter(entidad => 
      entidad.toLowerCase().includes(searchEntidad.toLowerCase())
    );
  }, [entidadesUnicas, searchEntidad]);

  // Datos filtrados
  const dataFiltrada = useMemo(() => {
    const q = busqueda.trim().toLowerCase();
    let filtered = dataAgrupada.filter((item) => {
      // Búsqueda global (9a): descripción, entidad y nomenclatura a la vez
      const coincideBusqueda = q === '' ||
        (item.descripcion_proceso || '').toLowerCase().includes(q) ||
        (item.entidad || '').toLowerCase().includes(q) ||
        (item.nomenclatura || '').toLowerCase().includes(q);

      const coincideEntidad = entidadesSeleccionadas.length === 0 ||
        entidadesSeleccionadas.includes(item.entidad);

      const coincideDescripcion = filtroDescripcion.trim() === '' ||
        (item.descripcion_proceso || '').toLowerCase().includes(filtroDescripcion.toLowerCase());
      
      const coincideTipoProceso = filtroTipoProceso === '' || 
        (item.tipo_proceso || '').toLowerCase() === filtroTipoProceso.toLowerCase();

      const coincideNomenclatura = filtroNomenclatura.trim() === '' || 
        (item.nomenclatura || '').toLowerCase().includes(filtroNomenclatura.toLowerCase());

      const coincideObjeto = filtroObjeto === '' || 
        (item.objet || '').toLowerCase() === filtroObjeto.toLowerCase();

      const coincideDepartamento = filtroDepartamento === '' || 
        (item.departamento || '').toLowerCase() === filtroDepartamento.toLowerCase();

      const coincideProvincia = filtroProvincia === '' || 
        (item.provincia || '').toLowerCase() === filtroProvincia.toLowerCase();

      // Nuevo filtro para distrito
      const coincideDistrito = filtroDistrito === '' || 
        (item.distrito || '').toLowerCase() === filtroDistrito.toLowerCase();

      // Filtro de procesos revisados
const coincideEstadoRevision = 
  filtroEstadoRevision === 'todos' || 
  (filtroEstadoRevision === 'pendientes' && !isProcessReviewed(item)) ||
  (filtroEstadoRevision === 'revisados' && isProcessReviewed(item));

      return coincideBusqueda && coincideDepartamento && coincideProvincia && coincideDistrito &&
             coincideEntidad && coincideDescripcion && coincideTipoProceso &&
             coincideNomenclatura && coincideObjeto && coincideEstadoRevision;
    });

    // Aplicar ordenamiento
    if (sortConfig.key) {
      filtered.sort((a, b) => {
        const aValue = a[sortConfig.key] || '';
        const bValue = b[sortConfig.key] || '';
        
        if (sortConfig.key.includes('fecha') || sortConfig.key.includes('created_at')) {
          const aDate = new Date(aValue);
          const bDate = new Date(bValue);
          return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
        }
        
        if (sortConfig.key === 'num_proceso' || sortConfig.key === 'total_items') {
          const aNum = Number(aValue) || 0;
          const bNum = Number(bValue) || 0;
          return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return filtered;
}, [dataAgrupada, entidadesSeleccionadas, busqueda,
    filtroDescripcion, filtroTipoProceso, filtroNomenclatura,
    filtroObjeto, filtroDepartamento, filtroProvincia, filtroDistrito, // Agregado filtroDistrito
    sortConfig, filtroEstadoRevision, processosRevisados]);

  // Datos paginados
  const dataPaginada = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return dataFiltrada.slice(start, start + itemsPerPage);
  }, [dataFiltrada, currentPage, itemsPerPage]);

  const totalPages = Math.ceil(dataFiltrada.length / itemsPerPage);

  // Componente para estadísticas de revisión
  const ReviewStats = () => {
    const totalProcesos = dataAgrupada.length;
    const procesosRevisadosCount = dataAgrupada.filter(isProcessReviewed).length;
    const procesosPendientes = totalProcesos - procesosRevisadosCount;
    const porcentajeRevisado = totalProcesos > 0 ? Math.round((procesosRevisadosCount / totalProcesos) * 100) : 0;
    
    return (
      <div className="d-flex flex-wrap gap-2 align-items-center">
        <Badge color="primary" style={{ fontSize: '11px', padding: '6px 12px', fontWeight: '600' }}>
          📊 Total: {totalProcesos}
        </Badge>
        <Badge color="success" style={{ fontSize: '11px', padding: '6px 12px', fontWeight: '600' }}>
          ✅ Revisados: {procesosRevisadosCount}
        </Badge>
        <Badge color="warning" style={{ fontSize: '11px', padding: '6px 12px', fontWeight: '600' }}>
          📋 Pendientes: {procesosPendientes}
        </Badge>
        <Badge color="info" style={{ fontSize: '11px', padding: '6px 12px', fontWeight: '600' }}>
          📈 {porcentajeRevisado}%
        </Badge>
      </div>
    );
  };
const ReviewCheckbox = ({ process, className = "" }) => {
  const isReviewed = isProcessReviewed(process);
  const [addingToCalendar, setAddingToCalendar] = useState(false);
  const [alreadyAdded, setAlreadyAdded] = useState(false);
  
  const userEmail = user?.email;
  
  useEffect(() => {
    const checkIfAdded = async () => {
      if (!userEmail) return;
      
      try {
        const { data, error } = await supabase
          .from('calendar_events')
          .select('id')
          .eq('user_id', userEmail)
          .eq('nomenclatura', process.nomenclatura)
          .eq('fuente', 'SEACE')
          .limit(1);

        if (error) throw error;
        setAlreadyAdded(data && data.length > 0);
      } catch (error) {
        devError('Error verificando calendario:', error);
      }
    };

    if (process.nomenclatura) {
      checkIfAdded();
    }
  }, [process.nomenclatura, userEmail]);
  
  const handleClick = async () => {
    if (!userEmail) {
      alert('Usuario no identificado. Por favor, verifica tu sesión.');
      return;
    }
    
    await toggleProcessReviewed(process, userEmail);
  };

  const addToCalendar = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!userEmail) {
      alert('Usuario no identificado');
      return;
    }

    if (alreadyAdded) {
      alert('Este proceso ya está agregado al calendario');
      return;
    }

    setAddingToCalendar(true);
    
    try {
      const eventos = [];
      
      // Agregar evento de inicio de registro
      if (process.fecha_inicio_participantes) {
        eventos.push({
          user_id: userEmail,
          nomenclatura: process.nomenclatura,
          entidad: process.entidad,
          descripcion_proceso: process.descripcion_proceso,
          tipo_evento: 'inicio_registro',
          fecha_evento: process.fecha_inicio_participantes,
          fuente: 'SEACE',
          departamento: process.departamento,
          objeto: process.objet,
          created_at: new Date().toISOString()
        });
      }

      // Agregar evento de fin de registro
      if (process.fecha_fin_participantes) {
        eventos.push({
          user_id: userEmail,
          nomenclatura: process.nomenclatura,
          entidad: process.entidad,
          descripcion_proceso: process.descripcion_proceso,
          tipo_evento: 'fin_registro',
          fecha_evento: process.fecha_fin_participantes,
          fuente: 'SEACE',
          departamento: process.departamento,
          objeto: process.objet,
          created_at: new Date().toISOString()
        });
      }

      // Agregar evento de presentación de propuestas
      if (process.fecha_presentacion_propuestas) {
        eventos.push({
          user_id: userEmail,
          nomenclatura: process.nomenclatura,
          entidad: process.entidad,
          descripcion_proceso: process.descripcion_proceso,
          tipo_evento: 'presentacion_propuestas',
          fecha_evento: process.fecha_presentacion_propuestas,
          fuente: 'SEACE',
          departamento: process.departamento,
          objeto: process.objet,
          created_at: new Date().toISOString()
        });
      }

      // Agregar evento de convocatoria
      if (process.fecha_convocatoria) {
        eventos.push({
          user_id: userEmail,
          nomenclatura: process.nomenclatura,
          entidad: process.entidad,
          descripcion_proceso: process.descripcion_proceso,
          tipo_evento: 'convocatoria',
          fecha_evento: process.fecha_convocatoria,
          fuente: 'SEACE',
          departamento: process.departamento,
          objeto: process.objet,
          created_at: new Date().toISOString()
        });
      }

      if (eventos.length > 0) {
        const { error } = await supabase
          .from('calendar_events')
          .insert(eventos);

        if (error) throw error;
        
        setAlreadyAdded(true);
        showToast(`✅ Se agregaron ${eventos.length} eventos al calendario`, 'success');
      } else {
        showToast('⚠️ No hay fechas disponibles para agregar al calendario', 'warning');
      }
      
    } catch (error) {
      devError('Error agregando al calendario:', error);
      showToast(`❌ Error al agregar al calendario: ${error.message}`, 'danger');
    } finally {
      setAddingToCalendar(false);
    }
  };
return (
  <div className={`d-flex ${isMobile ? 'flex-row' : 'flex-column'} align-items-center gap-2 ${className}`} style={{ minWidth: isMobile ? 'auto' : '100px' }}>
      <div 
        onClick={handleClick}
        style={{ cursor: userEmail ? 'pointer' : 'not-allowed' }}
      >
        <Input
          type="checkbox"
          checked={isReviewed}
          onChange={() => {}}
          disabled={!userEmail}
          style={{
            transform: 'scale(1.2)',
            cursor: userEmail ? 'pointer' : 'not-allowed'
          }}
        />
        {isReviewed && !isMobile && (
          <Label 
            className="mb-0 text-success fw-bold ms-2"
            style={{ 
              cursor: 'pointer',
              fontSize: '12px',
              userSelect: 'none'
            }}
          >
            Revisado
          </Label>
        )}
      </div>
      
      <Button
        onClick={addToCalendar}
        disabled={!userEmail || addingToCalendar || alreadyAdded}
        size="sm"
        color={alreadyAdded ? 'success' : 'primary'}
        style={{
          borderRadius: '8px',
          fontSize: '11px',
          padding: '4px 8px',
          fontWeight: '600',
          whiteSpace: 'nowrap',
          minWidth: '90px'
        }}
      >
        {addingToCalendar ? (
          <>
            <Spinner size="sm" className="me-1" />
            {isMobile ? '...' : 'Agregando...'}
          </>
        ) : alreadyAdded ? (
          <>
            <span className="me-1">✓</span>
            {isMobile ? 'En calendario' : 'Agregado'}
          </>
        ) : (
          <>
            <span className="me-1">📅</span>
            {isMobile ? 'Agregar' : 'Calendario'}
          </>
        )}
      </Button>
    </div>
  );
};
// Función para abrir el documento de bases
const openBases = (url) => {
  if (url && url.trim() !== '') {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    showToast('No hay URL de bases disponible para este proceso', 'warning');
  }
};
  // Funciones de utilidad
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-PE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'America/Lima' ,
      }).replace(/(\d{2})\/(\d{2})\/(\d{4}),?\s*(\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6');
    } catch (error) {
      return '-';
    }
  };

  const clearFilters = () => {
    setBusqueda('');
    setEntidadesSeleccionadas([]);
    setFiltroDescripcion('');
    setFiltroTipoProceso('');
    setFiltroNomenclatura('');
    setFiltroObjeto('');
    setFiltroDepartamento('');
    setFiltroProvincia('');
    setFiltroDistrito(''); // Limpiar filtro de distrito
   setFiltroEstadoRevision('todos');
    setSortConfig({ key: null, direction: 'asc' });
    setSearchEntidad('');
    setCurrentPage(1);
  };

  const openModal = (process) => {
    setSelectedProcess(process);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedProcess(null);
    setModalOpen(false);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return '⇅';
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  const getTypeColor = (tipo) => {
    const colors = {
      'BIEN': 'primary',
      'SERVICIO': 'success',
      'OBRA': 'warning',
      'CONSULTORÍA': 'info',
      'BIENES': 'primary',
      'SERVICIOS': 'success',
      'OBRAS': 'warning',
      'CONSULTORIA': 'info'
    };
    return colors[tipo?.toUpperCase()] || 'secondary';
  };

  const getMonedaColor = (moneda) => {
    const colors = {
      'SOLES': 'success',
      'S/': 'success',
      'PEN': 'success',
      'DOLARES': 'primary',
      'USD': 'primary',
      'EUROS': 'warning',
      'EUR': 'warning'
    };
    return colors[moneda?.toUpperCase()] || 'secondary';
  };

  // Funciones para manejar tooltips de descripción
  const handleMouseEnterDescription = (event, description) => {
    const rect = event.target.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 10
    });
    setHoveredDescription(description);
  };

  const handleMouseLeaveDescription = () => {
    setHoveredDescription(null);
  };

  // Funciones para manejar dropdowns
  const createDropdownHandlers = (
    selectedItems,
    setSelectedItems,
    setDropdownOpen,
    searchValue,
    setSearchValue
  ) => ({
    toggle: (item, event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setSelectedItems(prev => 
        prev.includes(item) 
          ? prev.filter(i => i !== item)
          : [...prev, item]
      );
    },
    selectAll: (allItems, event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setSelectedItems(allItems);
    },
    clear: (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setSelectedItems([]);
    },
    getButtonText: (allItems) => {
      if (selectedItems.length === 0) return `📋 Todas`;
      if (selectedItems.length === 1) return `📋 ${selectedItems[0]}`;
      return `📋 ${selectedItems.length} seleccionadas`;
    }
  });

  const entidadHandlers = createDropdownHandlers(
    entidadesSeleccionadas,
    setEntidadesSeleccionadas,
    setDropdownEntidad,
    searchEntidad,
    setSearchEntidad
  );

  const CustomDropdown = ({ 
    isOpen, 
    toggle, 
    buttonText, 
    items, 
    filteredItems, 
    selectedItems, 
    searchValue, 
    setSearchValue, 
    handlers, 
    dropdownRef, 
    placeholder,
    icon = "📋"
  }) => (
    <div ref={dropdownRef} style={{ position: 'relative', zIndex: 1000 }}>
      <Dropdown 
        isOpen={isOpen} 
        toggle={() => {}}
        className="w-100" 
        direction="down"
      >
        <DropdownToggle 
          caret 
          className="form-select-modern w-100 d-flex justify-content-between align-items-center"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle(e);
          }}
          style={{ 
            textAlign: 'left',
            backgroundColor: '#f8f9ba',
            border: '2px solid #e9ecef',
            borderRadius: '12px',
            padding: '12px 16px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            color: '#495057'
          }}
        >
          <span className="scn9-entity-name">{buttonText}</span>
        </DropdownToggle>
        <DropdownMenu 
          className="scn9-entity-menu"
          style={{ 
            maxHeight: '350px', 
            overflowY: 'auto',
            border: '2px solid #e9ecef',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
            position: 'absolute',
            zIndex: 9999,
            backgroundColor: '#ffffff',
            minWidth: '100%',
            left: 0,
            right: 'auto',
            transform: 'none',
            marginTop: '4px'
          }}
        >
          <div 
            className="p-3 border-bottom bg-light" 
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Input
              type="text"
              placeholder={placeholder}
              value={searchValue}
              onChange={(e) => {
                e.stopPropagation();
                setSearchValue(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              onFocus={(e) => {
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onInput={(e) => {
                e.stopPropagation();
              }}
              onKeyUp={(e) => {
                e.stopPropagation();
              }}
              onBlur={(e) => {
                e.preventDefault();
              }}
              className="form-control-sm"
              style={{
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                fontSize: '13px',
                color: '#495057'
              }}
              autoComplete="off"
              autoFocus={isOpen}
            />
          </div>
          
          <div className="p-2 border-bottom bg-light">
            <div className="d-flex justify-content-between">
              <Button
                color="link"
                size="sm"
                className="p-1 text-decoration-none fw-bold text-success"
                onClick={(e) => handlers.selectAll(items, e)}
                style={{ fontSize: '12px' }}
              >
                ✅ Seleccionar Todos
              </Button>
              <Button
                color="link"
                size="sm"
                className="p-1 text-decoration-none fw-bold text-danger"
                onClick={(e) => handlers.clear(e)}
                style={{ fontSize: '12px' }}
              >
                🗑️ Limpiar
              </Button>
            </div>
          </div>

          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <DropdownItem
                key={item}
                className="d-flex align-items-center justify-content-between py-2 px-3"
                onClick={(e) => handlers.toggle(item, e)}
                style={{ 
                  cursor: 'pointer',
                  fontSize: '13px',
                  transition: 'background-color 0.2s ease',
                  color: '#495057'
                }}
                toggle={false}
              >
                <span className="scn9-entity-name me-2" style={{ fontWeight: '500', color: '#495057' }}>{item}</span>
                {selectedItems.includes(item) && (
                  <span className="text-success fw-bold">✓</span>
                )}
              </DropdownItem>
            ))
          ) : (
            <DropdownItem disabled>
              <span className="text-muted fst-italic">No se encontraron resultados</span>
            </DropdownItem>
          )}
          
          <div className="p-3 border-top text-center bg-light">
            <Button
              color="primary"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                toggle();
              }}
              style={{
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '12px',
                padding: '8px 16px'
              }}
            >
              ✅ Aplicar Filtros
            </Button>
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );

  // Componente de paginación
  const PaginationComponent = () => {
    const pageNumbers = (() => {
      const pages = [];
      const maxPagesToShow = isMobile ? 3 : 5;
      if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i++) pages.push(i);
        return pages;
      }
      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
      const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
      if (endPage - startPage + 1 < maxPagesToShow) startPage = Math.max(1, endPage - maxPagesToShow + 1);
      for (let i = startPage; i <= endPage; i++) pages.push(i);
      if (!pages.includes(totalPages)) {
        pages.push('…');
        pages.push(totalPages);
      }
      return pages;
    })();

    const desde = dataFiltrada.length === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const hasta = Math.min(currentPage * itemsPerPage, dataFiltrada.length);

    return (
      <div className="scn9-pg">
        <span className="scn9-pg-info">
          Mostrando <b>{desde}–{hasta}</b> de {dataFiltrada.length.toLocaleString('es-PE')} convocatorias
        </span>
        <div className="scn9-pg-right">
          <div className="scn9-pg-perpage">
            <span>Por página</span>
            <select
              value={itemsPerPage}
              onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
            >
              {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
          <div className="scn9-pg-pages">
            <button
              className="scn9-pg-btn"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((c) => Math.max(1, c - 1))}
            >
              <FiChevronLeft />
            </button>
            {pageNumbers.map((n, k) =>
              n === '…' ? (
                <span key={`e${k}`} className="scn9-pg-dots">…</span>
              ) : (
                <button
                  key={n}
                  className={`scn9-pg-btn ${n === currentPage ? 'is-active' : ''}`}
                  onClick={() => setCurrentPage(n)}
                >
                  {n}
                </button>
              )
            )}
            <button
              className="scn9-pg-btn"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((c) => Math.min(totalPages, c + 1))}
            >
              <FiChevronRight />
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Tooltip personalizado para descripciones
  const DescriptionTooltip = () => {
    if (!hoveredDescription) return null;

    return (
      <div
        style={{
          position: 'fixed',
          left: `${tooltipPosition.x}px`,
          top: `${tooltipPosition.y}px`,
          transform: 'translateX(-50%) translateY(-100%)',
          backgroundColor: '#343a40',
          color: 'white',
          padding: '12px 16px',
          borderRadius: '8px',
          fontSize: '13px',
          lineHeight: '1.4',
          maxWidth: '400px',
          zIndex: 10000,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          border: '1px solid #495057',
          fontWeight: '500'
        }}
      >
        {hoveredDescription}
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid #343a40'
          }}
        />
      </div>
    );
  };

  // Componente de tarjeta móvil para cada proceso
const MobileProcessCard = ({ proceso, index }) => (
  <Card 
    className={`mb-3 shadow-sm ${isProcessReviewed(proceso) ? 'border-success' : ''}`}
    style={{ 
      borderRadius: '16px',
      backgroundColor: isProcessReviewed(proceso)
        ? '#ecfeff'
        : '#ffffff',
      border: isProcessReviewed(proceso) ? '2px solid #06b6d4' : '1px solid #e9ecef',
      borderLeft: isProcessReviewed(proceso) ? '5px solid #06b6d4' : '5px solid #0891b2',
      overflow: 'hidden'
    }}
  >
    <CardBody className="p-0">
      {/* HEADER NARANJA CON BADGES */}
      <div style={{
       background: 'linear-gradient(135deg, #1e3a5f 0%, #06b6d4 100%)',
        padding: '12px',
        marginBottom: '12px'
      }}>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0 text-white fw-bold" style={{ fontSize: '13px' }}>
            📋 {proceso.nomenclatura || 'Sin nomenclatura'}
          </h6>
          <ReviewCheckbox process={proceso} />
        </div>
        
        <div className="d-flex gap-2 flex-wrap">
          <Badge 
            color="light"
            style={{
              fontSize: '10px',
              fontWeight: '600',
              padding: '4px 8px',
              borderRadius: '12px',
              color: '#06b6d4'
            }}
          >
            {proceso.objet || 'N/A'}
          </Badge>
          <Badge 
            color="light"
            style={{
              fontSize: '10px',
              fontWeight: '600',
              padding: '4px 8px',
              borderRadius: '12px',
              color: '#0891b2'
            }}
          >
            {proceso.total_items} items
          </Badge>
        </div>
      </div>

      {/* CONTENIDO DE LA TARJETA */}
      <div className="px-3 pb-3">
        {/* Entidad */}
        <div className="mb-3 pb-3" style={{ borderBottom: '2px solid #f8f9fa' }}>
          <div className="d-flex align-items-start gap-2 mb-2">
            <span style={{ fontSize: '16px' }}>🏛️</span>
            <div style={{ flex: 1 }}>
              <small className="text-muted d-block mb-1" style={{ fontSize: '11px', fontWeight: '600' }}>
                ENTIDAD
              </small>
              <p className="mb-0 text-dark" style={{ fontSize: '13px', fontWeight: '500', lineHeight: '1.4', overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                {proceso.entidad || 'N/A'}
              </p>
            </div>
          </div>
        </div>

        {/* Descripción */}
        <div className="mb-3 pb-3" style={{ borderBottom: '2px solid #f8f9fa' }}>
          <div className="d-flex align-items-start gap-2">
            <span style={{ fontSize: '16px' }}>📝</span>
            <div style={{ flex: 1 }}>
              <small className="text-muted d-block mb-1" style={{ fontSize: '11px', fontWeight: '600' }}>
                DESCRIPCIÓN
              </small>
              <p className="mb-0 text-dark" style={{ fontSize: '13px', lineHeight: '1.4', overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                {proceso.descripcion_proceso || 'Sin descripción'}
              </p>
            </div>
          </div>
        </div>

        {/* Ubicación */}
        <div className="mb-3 pb-3" style={{ borderBottom: '2px solid #f8f9fa' }}>
          <div className="d-flex align-items-start gap-2">
            <span style={{ fontSize: '16px' }}>📍</span>
            <div style={{ flex: 1 }}>
              <small className="text-muted d-block mb-1" style={{ fontSize: '11px', fontWeight: '600' }}>
                UBICACIÓN
              </small>
              <p className="mb-0 text-dark" style={{ fontSize: '13px', fontWeight: '500' }}>
                {proceso.departamento}, {proceso.provincia}
              </p>
            </div>
          </div>
        </div>

        {/* Tipo de Proceso */}
        <div className="mb-3 pb-3" style={{ borderBottom: '2px solid #f8f9fa' }}>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: '16px' }}>⚙️</span>
              <small className="text-muted" style={{ fontSize: '11px', fontWeight: '600' }}>
                TIPO DE PROCESO
              </small>
            </div>
            <Badge 
              color={getTypeColor(proceso.tipo_proceso)}
              style={{ fontSize: '10px', padding: '4px 8px', borderRadius: '12px' }}
            >
              {proceso.tipo_proceso || 'N/A'}
            </Badge>
          </div>
        </div>

        {/* Fechas Importantes */}
        <div className="mb-3 pb-3" style={{ borderBottom: '2px solid #f8f9fa' }}>
          <div className="d-flex align-items-start gap-2 mb-2">
            <span style={{ fontSize: '16px' }}>📅</span>
            <small className="text-muted" style={{ fontSize: '11px', fontWeight: '600' }}>
              FECHAS IMPORTANTES
            </small>
          </div>
          <div style={{ 
            background: '#f8f9fa', 
            borderRadius: '8px', 
            padding: '10px',
            fontSize: '11px'
          }}>
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">Inicio Registro:</span>
              <span className="fw-bold text-dark">{formatDateFromSupabase(proceso.fecha_inicio_participantes)}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">Fin Registro:</span>
              <span className="fw-bold text-danger">{formatDateFromSupabase(proceso.fecha_fin_participantes)}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">Presentación:</span>
              <span className="fw-bold text-warning">{formatDateFromSupabase(proceso.fecha_presentacion_propuestas)}</span>
            </div>
          </div>
        </div>

        {/* Botones de Acción */}
        <div className="d-flex gap-2">
          <Button
            color="success"
            size="sm"
            onClick={() => openModal(proceso)}
            className="flex-fill"
            style={{
              borderRadius: '10px',
              fontWeight: '600',
              padding: '10px',
              fontSize: '12px',
              border: 'none'
            }}
          >
            Ver Detalles
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => openBases(proceso.url_doc)}
            disabled={!proceso.url_doc || proceso.url_doc.trim() === ''}
            className="flex-fill"
            style={{
              borderRadius: '10px',
              fontWeight: '600',
              padding: '10px',
              fontSize: '12px',
              border: 'none',
              opacity: (!proceso.url_doc || proceso.url_doc.trim() === '') ? 0.5 : 1
            }}
          >
            📄 Bases
          </Button>
        </div>
      </div>
    </CardBody>
  </Card>
);
  // ══════════════════════════════════════════════════════════════
  //  9a — Rediseño "Contratos Mayores · Nuevas Convocatorias"
  //  (lista de 6 columnas + panel lateral de detalle)
  // ══════════════════════════════════════════════════════════════

  // Días hasta una fecha (usa fin del día). null si no hay fecha válida
  const diasHasta = (fecha) => {
    if (!fecha) return null;
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return null;
    d.setHours(23, 59, 59, 999);
    return Math.ceil((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  };

  // Badge "cierra en" según el fin de registro
  const cierreBadge = (proceso) => {
    const dias = diasHasta(proceso.fecha_fin_participantes);
    if (dias === null) return { label: 'Sin fecha', level: 'none', color: '#8a94a6', bg: '#f1f4f8' };
    if (dias < 0) return { label: 'Cerrado', level: 'none', color: '#8a94a6', bg: '#f1f4f8' };
    if (dias === 0) return { label: 'Hoy', level: 'urg', color: '#b42318', bg: '#fdeceb' };
    if (dias === 1) return { label: 'Mañana', level: 'urg', color: '#b42318', bg: '#fdeceb' };
    if (dias <= 6) return { label: `${dias} días`, level: 'urg', color: '#b42318', bg: '#fdeceb' };
    if (dias <= 30) return { label: `${dias} días`, level: 'mid', color: '#8a5308', bg: '#fdf3e6' };
    return { label: `${dias} días`, level: 'far', color: '#475569', bg: '#f1f4f8' };
  };

  // Fecha corta "DD/MM · HH:mm"
  const fechaCorta = (fecha) => {
    if (!fecha) return '—';
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return '—';
    const p = (n) => String(n).padStart(2, '0');
    return `${p(d.getDate())}/${p(d.getMonth() + 1)} · ${p(d.getHours())}:${p(d.getMinutes())}`;
  };

  // Color del badge de objeto contractual (paleta por tipo)
  const objetoColor = (objeto) => {
    const o = (objeto || '').toLowerCase();
    if (o.includes('consult')) return { color: '#14507d', bg: '#eff6fb', border: '#d3e3ef', dot: '#14507d' };
    if (o.includes('obra')) return { color: '#7a4a10', bg: '#fdf3e6', border: '#eddcbf', dot: '#a86a12' };
    if (o.includes('servici')) return { color: '#0f4f47', bg: '#e8f2f0', border: '#cfe6dd', dot: '#0f766e' };
    if (o.includes('bien')) return { color: '#5b3fa8', bg: '#f3effe', border: '#e2d5fb', dot: '#6d28d9' };
    return { color: '#5b6779', bg: '#f1f4f8', border: '#e2e6ee', dot: '#8a94a6' };
  };

  // Agregar un proceso al calendario (con verificación de duplicados)
  const agregarAlCalendario = async (process) => {
    const userEmail = user?.email;
    if (!userEmail) { showToast('Usuario no identificado', 'warning'); return; }
    try {
      const { data: existentes } = await supabase
        .from('calendar_events')
        .select('id')
        .eq('user_id', userEmail)
        .eq('nomenclatura', process.nomenclatura)
        .eq('fuente', 'SEACE')
        .limit(1);
      if (existentes && existentes.length > 0) {
        showToast('Este proceso ya está en el calendario', 'info');
        return;
      }
      const eventos = [];
      const push = (tipo, fecha) => {
        if (fecha) eventos.push({
          user_id: userEmail,
          nomenclatura: process.nomenclatura,
          entidad: process.entidad,
          descripcion_proceso: process.descripcion_proceso,
          tipo_evento: tipo,
          fecha_evento: fecha,
          fuente: 'SEACE',
          departamento: process.departamento,
          objeto: process.objet,
          created_at: new Date().toISOString(),
        });
      };
      push('inicio_registro', process.fecha_inicio_participantes);
      push('fin_registro', process.fecha_fin_participantes);
      push('presentacion_propuestas', process.fecha_presentacion_propuestas);
      push('convocatoria', process.fecha_convocatoria);
      if (eventos.length === 0) { showToast('No hay fechas para agregar', 'warning'); return; }
      const { error: insErr } = await supabase.from('calendar_events').insert(eventos);
      if (insErr) throw insErr;
      setCalEventos((prev) => [...prev, ...eventos.map(({ nomenclatura, fecha_evento, tipo_evento }) => ({ nomenclatura, fecha_evento, tipo_evento }))]);
      showToast(`Se agregaron ${eventos.length} eventos al calendario`, 'success');
    } catch (e) {
      devError('Error agregando al calendario:', e);
      showToast(`Error al agregar al calendario: ${e.message}`, 'danger');
    }
  };

  // Quitar del calendario: borra los hitos SEACE de esa convocatoria. El mismo
  // icono sirve para poner y quitar, sin pasar por el Calendario de Procesos.
  const quitarDelCalendario = async (process) => {
    const userEmail = user?.email;
    if (!userEmail) { showToast('Usuario no identificado', 'warning'); return; }
    try {
      const { error: delErr } = await supabase
        .from('calendar_events')
        .delete()
        .eq('user_id', userEmail)
        .eq('nomenclatura', process.nomenclatura)
        .eq('fuente', 'SEACE');
      if (delErr) throw delErr;
      setCalEventos((prev) => prev.filter((ev) => ev.nomenclatura !== process.nomenclatura));
      showToast('Se quitó del calendario', 'success');
    } catch (e) {
      devError('Error quitando del calendario:', e);
      showToast(`Error al quitar del calendario: ${e.message}`, 'danger');
    }
  };


  // ── Panel lateral de detalle ────────────────────────────────
  const procesoPanel = (panelIndex != null && panelIndex >= 0 && panelIndex < dataFiltrada.length)
    ? dataFiltrada[panelIndex] : null;
  const abrirPanel = (globalIndex) => {
    setPanelIndex(globalIndex);
    setCurrentPage(Math.floor(globalIndex / itemsPerPage) + 1);
  };
  const cerrarPanel = () => setPanelIndex(null);
  const panelNav = (delta) => {
    setPanelIndex((i) => {
      const base = i == null ? 0 : i;
      const n = Math.min(dataFiltrada.length - 1, Math.max(0, base + delta));
      setCurrentPage(Math.floor(n / itemsPerPage) + 1);
      return n;
    });
  };
  const marcarYSiguiente = async () => {
    if (procesoPanel && user?.email) await toggleProcessReviewed(procesoPanel, user.email);
    panelNav(1);
  };

  // Navegación por teclado (J / K / E / Escape) con el panel abierto
  useEffect(() => {
    const onKey = (e) => {
      if (isMobile || panelIndex == null) return;
      const tag = e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      const k = e.key.toLowerCase();
      if (k === 'j') { e.preventDefault(); panelNav(1); }
      else if (k === 'k') { e.preventDefault(); panelNav(-1); }
      else if (k === 'e') { e.preventDefault(); marcarYSiguiente(); }
      else if (e.key === 'Escape') { cerrarPanel(); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panelIndex, dataFiltrada.length, itemsPerPage, isMobile]);

  const revisadasCount = dataAgrupada.filter(isProcessReviewed).length;

  // --- KPIs de cabecera (sobre el total del día, no sobre el filtrado) ---
  // ── Convocatorias en el calendario del usuario ──────────────────────────
  // Una sola lectura de `calendar_events` por usuario: alimenta la casilla
  // «En mi calendario» y se actualiza en local al añadir, sin volver a pedir.
  // Solo la fuente SEACE: esta pantalla no debe contar los contratos menores
  // ni el PAC, que tienen su propia casilla en sus páginas.
  const [calEventos, setCalEventos] = useState([]);

  useEffect(() => {
    const email = user?.email;
    if (!email) { setCalEventos([]); return; }
    let vigente = true;
    (async () => {
      try {
        const { data: filas, error: err } = await supabase
          .from('calendar_events')
          .select('nomenclatura, fecha_evento, tipo_evento')
          .eq('user_id', email)
          .eq('fuente', 'SEACE');
        if (err) throw err;
        if (vigente) setCalEventos(filas || []);
      } catch (e) {
        // La casilla se oculta sola si no hay datos; no interrumpe la página
        devError('Error leyendo el calendario del usuario:', e);
      }
    })();
    return () => { vigente = false; };
  }, [user?.email]);

  // Códigos ya guardados, para marcar el icono de cada fila
  const codigosEnCalendario = useMemo(
    () => new Set(calEventos.map((ev) => ev.nomenclatura).filter(Boolean)),
    [calEventos]
  );

  // Un clic pone la convocatoria en el calendario; el siguiente la saca.
  // `calOcupado` evita el doble clic mientras la consulta está en vuelo.
  const [calOcupado, setCalOcupado] = useState(null);

  const alternarCalendario = async (process) => {
    if (!process?.nomenclatura || calOcupado) return;
    setCalOcupado(process.nomenclatura);
    try {
      if (codigosEnCalendario.has(process.nomenclatura)) {
        await quitarDelCalendario(process);
      } else {
        await agregarAlCalendario(process);
      }
    } finally {
      setCalOcupado(null);
    }
  };

  // Convocatorias distintas con alguna fecha por delante, y cuántas de ellas
  // cierran dentro de la semana. Un acumulado histórico solo crecería.
  const calendarioKpi = useMemo(() => {
    const ahora = Date.now();
    const limite = ahora + 7 * 24 * 60 * 60 * 1000;
    const activas = new Set();
    const cierranSemana = new Set();
    calEventos.forEach((ev) => {
      if (!ev.nomenclatura) return;
      const t = new Date(ev.fecha_evento).getTime();
      if (isNaN(t) || t < ahora) return;
      activas.add(ev.nomenclatura);
      if (t <= limite && (ev.tipo_evento === 'fin_registro' || ev.tipo_evento === 'presentacion_propuestas')) {
        cierranSemana.add(ev.nomenclatura);
      }
    });
    return { activas: activas.size, cierranSemana: cierranSemana.size };
  }, [calEventos]);

  const kpis = useMemo(() => {
    const total = dataAgrupada.length;
    const revisadas = dataAgrupada.filter(isProcessReviewed).length;
    const pendientes = total - revisadas;
    const pct = total > 0 ? Math.round((revisadas / total) * 100) : 0;

    // Reparto por objeto contractual, con las familias más frecuentes primero
    const conteo = {};
    dataAgrupada.forEach((i) => {
      const o = (i.objet || '').toLowerCase();
      const clave = o.includes('consult')
        ? 'consultorías'
        : o.includes('obra')
          ? 'obras'
          : o.includes('servici')
            ? 'servicios'
            : o.includes('bien')
              ? 'bienes'
              : 'otros';
      conteo[clave] = (conteo[clave] || 0) + 1;
    });
    const reparto = ['servicios', 'consultorías', 'obras', 'bienes', 'otros']
      .filter((k) => conteo[k])
      .map((k) => ({ label: k, count: conteo[k], cls: k.startsWith('consult') ? 'consultoria' : { servicios: 'servicio', bienes: 'bien', obras: 'obra', otros: 'otro' }[k] }));

    // Cierres dentro de los próximos 7 días y el más inminente
    let cierran7 = 0;
    let proxima = null;
    dataAgrupada.forEach((i) => {
      const d = diasHasta(i.fecha_fin_participantes);
      if (d === null || d < 0) return;
      if (d <= 7) cierran7 += 1;
      const fin = new Date(i.fecha_fin_participantes);
      if (isNaN(fin.getTime()) || fin.getTime() < Date.now()) return;
      if (!proxima || fin.getTime() < proxima.getTime()) proxima = fin;
    });
    let proximaLabel = null;
    if (proxima) {
      const d = diasHasta(proxima.toISOString());
      const hora = `${String(proxima.getHours()).padStart(2, '0')}:${String(proxima.getMinutes()).padStart(2, '0')}`;
      const cuando = d === 0 ? 'hoy' : d === 1 ? 'mañana' : `en ${d} días`;
      proximaLabel = `${cuando} ${hora}`;
    }

    const entidades = new Set(dataAgrupada.map((i) => i.entidad).filter(Boolean)).size;
    const departamentos = new Set(dataAgrupada.map((i) => i.departamento).filter(Boolean)).size;

    return { total, revisadas, pendientes, pct, reparto, cierran7, proximaLabel, entidades, departamentos };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAgrupada, processosRevisados]);

  // Opción de orden activa en el selector "Ordenar por"
  const ordenActual =
    ORDEN_OPCIONES.find((o) => o.key === sortConfig.key && o.dir === sortConfig.direction) ||
    ORDEN_OPCIONES[0];

  const aplicarOrden = (id) => {
    const op = ORDEN_OPCIONES.find((o) => o.id === id) || ORDEN_OPCIONES[0];
    setSortConfig({ key: op.key, direction: op.dir });
    setCurrentPage(1);
  };

  // WhatsApp se abre en el mismo gesto del clic: si se hiciera después de un
  // await, el navegador lo trataría como ventana emergente y la bloquearía.
  const compartirWhatsApp = (proceso) => {
    const mensaje = buildConvocatoriaMessage(proceso, enlaceDeBases(proceso.url_doc));
    const ventana = window.open(whatsappShareUrl(mensaje), '_blank');
    if (ventana) ventana.opener = null;
    else showToast('Permite las ventanas emergentes para abrir WhatsApp.', 'warning');
  };

  // Atajo del modal: abre el generador de oferta con la convocatoria elegida
  const generarOferta = (proceso) => {
    navigate('/SEACE/generador-oferta', { state: { proceso } });
  };
  const horaActualizado = globalSEACENuevosCache.timestamp
    ? new Date(globalSEACENuevosCache.timestamp).toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', hour12: false })
    : null;

  // Chips de filtros activos
  const contarPorFiltro = (pred) => dataAgrupada.filter(pred).length;
  const chipsActivos = [];
  if (filtroEstadoRevision !== 'todos') {
    chipsActivos.push({
      key: 'estado',
      label: filtroEstadoRevision === 'pendientes' ? 'Pendientes' : 'Revisados',
      count: filtroEstadoRevision === 'pendientes' ? (dataAgrupada.length - revisadasCount) : revisadasCount,
      clear: () => setFiltroEstadoRevision('todos'),
    });
  }
  if (filtroTipoProceso) chipsActivos.push({ key: 'tipo', label: filtroTipoProceso, count: contarPorFiltro((i) => (i.tipo_proceso || '').toLowerCase() === filtroTipoProceso.toLowerCase()), clear: () => setFiltroTipoProceso('') });
  if (filtroObjeto) chipsActivos.push({ key: 'objeto', label: filtroObjeto, count: contarPorFiltro((i) => (i.objet || '').toLowerCase() === filtroObjeto.toLowerCase()), clear: () => setFiltroObjeto('') });
  if (filtroDepartamento) chipsActivos.push({ key: 'depto', label: filtroDepartamento, count: contarPorFiltro((i) => (i.departamento || '').toLowerCase() === filtroDepartamento.toLowerCase()), clear: () => setFiltroDepartamento('') });
  if (filtroProvincia) chipsActivos.push({ key: 'prov', label: filtroProvincia, count: contarPorFiltro((i) => (i.provincia || '').toLowerCase() === filtroProvincia.toLowerCase()), clear: () => setFiltroProvincia('') });
  if (filtroDistrito) chipsActivos.push({ key: 'dist', label: filtroDistrito, count: contarPorFiltro((i) => (i.distrito || '').toLowerCase() === filtroDistrito.toLowerCase()), clear: () => setFiltroDistrito('') });
  if (entidadesSeleccionadas.length) chipsActivos.push({ key: 'ent', label: entidadesSeleccionadas.length === 1 ? entidadesSeleccionadas[0] : `${entidadesSeleccionadas.length} entidades`, clear: () => setEntidadesSeleccionadas([]) });
  if (filtroNomenclatura) chipsActivos.push({ key: 'nom', label: `Nom: ${filtroNomenclatura}`, clear: () => setFiltroNomenclatura('') });
  if (filtroDescripcion) chipsActivos.push({ key: 'desc', label: `Desc: ${filtroDescripcion}`, clear: () => setFiltroDescripcion('') });

  // Fecha larga con hora "DD/MM/AAAA · HH:mm" para el cronograma del modal
  const fechaHora = (fecha) => {
    if (!fecha) return '—';
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return '—';
    const p = (n) => String(n).padStart(2, '0');
    return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} · ${p(d.getHours())}:${p(d.getMinutes())}`;
  };

  // Cuenta regresiva hasta el cierre del registro ("Cierra en 2 h 15 m")
  const cuentaRegresiva = (fecha) => {
    if (!fecha) return null;
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return null;
    const ms = d.getTime() - Date.now();
    if (ms <= 0) return { label: 'Registro cerrado', urgente: false };
    const dias = Math.floor(ms / 86400000);
    const horas = Math.floor((ms % 86400000) / 3600000);
    const mins = Math.floor((ms % 3600000) / 60000);
    if (dias >= 1) return { label: `Cierra en ${dias} d ${horas} h`, urgente: dias <= 1 };
    return { label: `Cierra en ${horas} h ${mins} m`, urgente: true };
  };

  // Estado relativo de un hito del cronograma (badge con color)
  const cronoEstado = (fecha, activo) => {
    if (activo) return { label: 'en curso', color: '#0f766e', bg: '#d6f0ea' };
    const dias = diasHasta(fecha);
    if (dias == null) return null;
    if (dias < 0) return { label: 'vencido', color: '#5b6779', bg: '#eef1f5' };
    if (dias === 0) return { label: 'hoy', color: '#b3261e', bg: '#fdeceb' };
    if (dias === 1) return { label: 'mañana', color: '#8a5308', bg: '#fdf3e6' };
    return { label: `en ${dias} días`, color: dias <= 6 ? '#8a5308' : '#5b6779', bg: dias <= 6 ? '#fdf3e6' : '#eef1f5' };
  };

  // ¿El registro está en curso? (entre inicio y fin de participantes)
  const registroEnCurso = (proceso) => {
    const a = proceso.fecha_inicio_participantes && new Date(proceso.fecha_inicio_participantes);
    const b = proceso.fecha_fin_participantes && new Date(proceso.fecha_fin_participantes);
    const now = Date.now();
    return a && b && !isNaN(a.getTime()) && !isNaN(b.getTime()) && a.getTime() <= now && now <= b.getTime();
  };

  // Progreso de la ventana de registro, para la barra del cronograma (16b)
  const ventanaRegistro = (proceso) => {
    const a = proceso.fecha_inicio_participantes && new Date(proceso.fecha_inicio_participantes);
    const b = proceso.fecha_fin_participantes && new Date(proceso.fecha_fin_participantes);
    if (!a || !b || isNaN(a.getTime()) || isNaN(b.getTime()) || b <= a) return null;
    const dia = 86400000;
    const totalDias = Math.max(1, Math.round((b.getTime() - a.getTime()) / dia));
    const transcurrido = Math.round((Date.now() - a.getTime()) / dia);
    const diaActual = Math.min(totalDias, Math.max(1, transcurrido + 1));
    const pct = Math.min(100, Math.max(0, ((Date.now() - a.getTime()) / (b.getTime() - a.getTime())) * 100));
    return { diaActual, totalDias, pct };
  };

  // Fila de cronograma del panel (timeline vertical con badge de estado)
  const renderCronoRow = (label, fecha, color, activo = false) => {
    const est = cronoEstado(fecha, activo);
    return (
      <div className="scn9-crono-row" key={label}>
        <div className="scn9-crono-rail">
          <span className="scn9-crono-dot" style={{ background: color }} />
        </div>
        <div className="scn9-crono-main">
          <div className="scn9-crono-label">{label}</div>
          <div className="scn9-crono-date">{fechaHora(fecha)}</div>
        </div>
        {est && <span className="scn9-crono-badge" style={{ color: est.color, background: est.bg }}>{est.label}</span>}
      </div>
    );
  };

  return (
    <div className="scn9">
      <DescriptionTooltip />

      {/* Toast */}
      {toastMessage && (
        <div className={`scn9-toast scn9-toast-${toastMessage.type}`}>{toastMessage.message}</div>
      )}

      {/* Cabecera */}
      <div className="scn9-head">
        <div className="scn9-head-titles">
          <div className="scn9-eyebrow">SEACE · CONTRATOS MAYORES</div>
          <h1 className="scn9-title">Nuevas Convocatorias</h1>
          <div className="scn9-sub">
            {kpis.total.toLocaleString('es-PE')} convocatorias nuevas
            {horaActualizado && <> · actualizado {horaActualizado}</>}
          </div>
        </div>
        <div className="scn9-head-actions">
          <button className="scn9-btn" onClick={refreshData} disabled={loading} hidden style={{ display: 'none' }}>
            <FiRefreshCw className={loading ? 'scn9-spin' : ''} />
            {loading ? 'Cargando…' : 'Actualizar'}
          </button>
          {user?.email && (
            <button className="scn9-btn scn9-btn-primary" onClick={markAllAsReviewed} disabled={loadingReviewed || dataFiltrada.length === 0}>
              <FiCheck /> Marcar todas revisadas
            </button>
          )}
        </div>
      </div>

      {/* KPIs del día */}
      {data.length > 0 && (
        <div className="scn9-kpis">
          <button
            type="button"
            className="scn9-kpi k-cal"
            onClick={() => navigate('/Calendario')}
            title="Ver las convocatorias del SEACE guardadas en tu calendario"
          >
            <div className="scn9-kpi-top">
              <span className="scn9-kpi-label">EN MI CALENDARIO</span>
              <span className="scn9-kpi-ic"><FiCalendar /></span>
            </div>
            <div className="scn9-kpi-val">{calendarioKpi.activas.toLocaleString('es-PE')}</div>
            <div className="scn9-kpi-foot spaced">
              {calendarioKpi.cierranSemana > 0
                ? <><b>{calendarioKpi.cierranSemana.toLocaleString('es-PE')}</b> {calendarioKpi.cierranSemana === 1 ? 'cierra' : 'cierran'} esta semana</>
                : calendarioKpi.activas > 0
                  ? 'Ninguna cierra esta semana'
                  : 'Aún no guardas convocatorias'}
              <span className="scn9-kpi-go">Ver calendario <FiCornerDownRight /></span>
            </div>
          </button>

          <div className="scn9-kpi k-inbox">
            <div className="scn9-kpi-top">
              <span className="scn9-kpi-label">CONVOCATORIAS NUEVAS</span>
              <span className="scn9-kpi-ic"><FiInbox /></span>
            </div>
            <div className="scn9-kpi-val">{kpis.total.toLocaleString('es-PE')}</div>
            <div className="scn9-kpi-foot spaced scn9-kpi-types">
              {kpis.reparto.length ? kpis.reparto.map((tipo) => (
                <span key={tipo.cls} className={`scn9-kpi-type scn9-kpi-type--${tipo.cls}`}>
                  <strong>{tipo.count.toLocaleString('es-PE')}</strong>
                  <span>{tipo.label}</span>
                </span>
              )) : 'Sin convocatorias'}
            </div>
          </div>

          <div className="scn9-kpi k-hoy">
            <div className="scn9-kpi-top">
              <span className="scn9-kpi-label">CIERRAN EN 7 DÍAS</span>
              <span className="scn9-kpi-ic warm"><FiClock /></span>
            </div>
            <div className="scn9-kpi-val">{kpis.cierran7.toLocaleString('es-PE')}</div>
            <div className="scn9-kpi-foot spaced">
              {kpis.proximaLabel ? (
                <>La más próxima cierra <b>{kpis.proximaLabel}</b></>
              ) : (
                'Sin registros abiertos'
              )}
            </div>
          </div>

          <div className="scn9-kpi k-ent">
            <div className="scn9-kpi-top">
              <span className="scn9-kpi-label">ENTIDADES CONVOCANTES</span>
              <span className="scn9-kpi-ic amber"><FiHome /></span>
            </div>
            <div className="scn9-kpi-val">{kpis.entidades.toLocaleString('es-PE')}</div>
            <div className="scn9-kpi-foot spaced">En {kpis.departamentos} departamento{kpis.departamentos === 1 ? '' : 's'}</div>
          </div>
        </div>
      )}

      {/* Error */}
      {error && <div className="scn9-alert">{error}</div>}

      {/* Carga */}
      {loading && (
        <div className="scn9-loading">
          <div className="scn9-loading-txt">
            Cargando nuevos procesos… {loadingProgress}%
            {currentBatch > 0 && totalBatches > 0 && <span> · Lote {currentBatch} de {totalBatches}</span>}
            {totalRecords > 0 && <span> · {data.length} de {totalRecords} registros</span>}
          </div>
          <div className="scn9-progress"><div className="scn9-progress-bar" style={{ width: `${loadingProgress}%` }} /></div>
        </div>
      )}

      {/* Sin datos */}
      {!loading && data.length === 0 && !error && (
        <div className="scn9-empty">
          <div className="scn9-empty-title">No hay procesos nuevos</div>
          <div className="scn9-empty-sub">Haz clic en «Cargar procesos» para consultar los últimos procesos SEACE.</div>
          <button className="scn9-btn scn9-btn-primary" onClick={refreshData}><FiRefreshCw /> Cargar procesos</button>
        </div>
      )}

      {data.length > 0 && (
        <>
          {/* Buscador + filtros */}
          <div className="scn9-filtercard">
            <div className="scn9-filters-top">
              <div className="scn9-searchbar">
                <FiSearch className="scn9-searchbar-ic" />
                <input
                  className="scn9-searchbar-input"
                  value={busqueda}
                  onChange={(e) => { setBusqueda(e.target.value); setCurrentPage(1); }}
                  placeholder="Busca a la vez en descripción, entidad y nomenclatura…"
                />
                {busqueda && <span className="scn9-searchbar-count">{dataFiltrada.length} resultados</span>}
                {busqueda && <button className="scn9-searchbar-clear" onClick={() => setBusqueda('')}><FiX /></button>}
              </div>
              <div className="scn9-tabs">
                {[
                  { k: 'todos', label: 'Todas', count: kpis.total },
                  { k: 'pendientes', label: 'Pendientes', count: kpis.pendientes },
                  { k: 'revisados', label: 'Revisadas', count: kpis.revisadas }
                ].map((t) => (
                  <button
                    key={t.k}
                    className={`scn9-tab ${filtroEstadoRevision === t.k ? 'is-active' : ''}`}
                    onClick={() => { setFiltroEstadoRevision(t.k); setCurrentPage(1); }}
                  >
                    {t.label} <span className="scn9-tab-count">{t.count}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="scn9-filters">
              <div className="scn9-filter-field scn9-entity-field">
                <label>Entidad</label>
                <CustomDropdown
                  isOpen={dropdownEntidad}
                  toggle={(e) => {
                    if (e && e.target) {
                      const isInputArea = e.target.tagName === 'INPUT' ||
                        e.target.closest('.p-3.border-bottom.bg-light') ||
                        e.target.classList.contains('form-control-sm');
                      if (isInputArea) return;
                    }
                    setDropdownEntidad(!dropdownEntidad);
                  }}
                  buttonText={entidadHandlers.getButtonText(entidadesUnicas)}
                  items={entidadesUnicas}
                  filteredItems={entidadesFiltradas}
                  selectedItems={entidadesSeleccionadas}
                  searchValue={searchEntidad}
                  setSearchValue={setSearchEntidad}
                  handlers={entidadHandlers}
                  dropdownRef={dropdownEntidadRef}
                  placeholder="Buscar entidad…"
                  icon=""
                />
              </div>
              <div className="scn9-filter-field">
                <label>Objeto contractual</label>
                <select className={`scn9-input ${filtroObjeto ? 'is-set' : ''}`} value={filtroObjeto} onChange={(e) => { setFiltroObjeto(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos los objetos</option>
                  {objetosUnicos.map((o) => <option key={o} value={o}>{o}</option>)}
                </select>
              </div>
              <div className="scn9-filter-field">
                <label>Procedimiento</label>
                <select className={`scn9-input ${filtroTipoProceso ? 'is-set' : ''}`} value={filtroTipoProceso} onChange={(e) => { setFiltroTipoProceso(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos los tipos</option>
                  {tiposProcesoUnicos.map((t) => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div className="scn9-filter-field">
                <label>Departamento</label>
                <select className={`scn9-input ${filtroDepartamento ? 'is-set' : ''}`} value={filtroDepartamento} onChange={(e) => { setFiltroDepartamento(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos los departamentos</option>
                  {departamentosUnicos.map((d) => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>
              <div className="scn9-filter-field">
                <label>Ordenar por</label>
                <select className="scn9-input has-value" value={ordenActual.id} onChange={(e) => aplicarOrden(e.target.value)}>
                  {ORDEN_OPCIONES.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
                </select>
              </div>

              <div className="scn9-filters-actions">
                {busqueda && (
                  <button className="scn9-chip" onClick={() => setBusqueda('')} title={busqueda}>
                    <span className="scn9-chip-txt">«{busqueda}»</span>
                    <FiX />
                  </button>
                )}
                {chipsActivos.map((c) => (
                  <button key={c.key} className="scn9-chip" onClick={() => { c.clear(); setCurrentPage(1); }} title={c.label}>
                    <span className="scn9-chip-txt">{c.label}</span>
                    {typeof c.count === 'number' && <b>{c.count}</b>}
                    <FiX />
                  </button>
                ))}
                {(chipsActivos.length > 0 || busqueda) && (
                  <button className="scn9-chip-clear" onClick={clearFilters}>Limpiar</button>
                )}
              </div>

              {/* Filtros de detalle (misma rejilla, segunda fila) */}
              <div className="scn9-filter-field">
                <label>Provincia</label>
                <select className={`scn9-input ${filtroProvincia ? 'is-set' : ''}`} value={filtroProvincia} onChange={(e) => { setFiltroProvincia(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todas las provincias</option>
                  {provinciasUnicas.map((p) => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
              <div className="scn9-filter-field">
                <label>Distrito</label>
                <select className={`scn9-input ${filtroDistrito ? 'is-set' : ''}`} value={filtroDistrito} onChange={(e) => { setFiltroDistrito(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos los distritos</option>
                  {distritosUnicos.map((d) => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>
              <div className="scn9-filter-field">
                <label>Nomenclatura</label>
                <input className={`scn9-input ${filtroNomenclatura ? 'is-set' : ''}`} type="text" placeholder="Ej: CP-ABR-1-2026" value={filtroNomenclatura} onChange={(e) => { setFiltroNomenclatura(e.target.value); setCurrentPage(1); }} />
              </div>
              <div className="scn9-filter-field">
                <label>Descripción</label>
                <input className={`scn9-input ${filtroDescripcion ? 'is-set' : ''}`} type="text" placeholder="Ej: consultoría, servicios…" value={filtroDescripcion} onChange={(e) => { setFiltroDescripcion(e.target.value); setCurrentPage(1); }} />
              </div>
            </div>
          </div>

          {/* Lista + panel lateral */}
          <div className="scn9-main">
            <div className="scn9-listcard">
              <div className="scn9-list-head">
                <div className="scn9-list-head-title">
                  <b>{dataFiltrada.length.toLocaleString('es-PE')} convocatorias</b>
                  <span>ordenadas por {ordenActual.label.toLowerCase()}</span>
                </div>
                <div className="scn9-legend">
                  <span className="lg-urg"><i />Cierra en ≤ 6 días</span>
                  <span className="lg-mid"><i />7 a 30 días</span>
                  <span className="lg-far"><i />Más de 30 días</span>
                </div>
              </div>

              {/* Cabecera de columnas */}
              <div className="scn9-row scn9-row-head">
                <div className="scn9-c-check">REV</div>
                <div className="scn9-c-conv">CONVOCATORIA</div>
                <div className="scn9-c-ent">ENTIDAD Y UBICACIÓN</div>
                <div className="scn9-c-tipo">OBJETO</div>
                <div className="scn9-c-cierra">CIERRA EN</div>
                <div className="scn9-c-acc">ACCIONES</div>
              </div>

              {dataPaginada.length === 0 ? (
                <div className="scn9-empty-list">No hay convocatorias que coincidan con los filtros.</div>
              ) : dataPaginada.map((proceso, idx) => {
                const globalIndex = (currentPage - 1) * itemsPerPage + idx;
                const rev = isProcessReviewed(proceso);
                const cb = cierreBadge(proceso);
                const oc = objetoColor(proceso.objet);
                const activo = panelIndex === globalIndex;
                return (
                  <div
                    key={`${proceso.nomenclatura}-${globalIndex}`}
                    className={`scn9-row scn9-row-item lvl-${cb.level} ${activo ? 'is-active' : ''} ${rev ? 'is-rev' : ''}`}
                  >
                    <div
                      className="scn9-c-check"
                      onClick={() => { if (user?.email) toggleProcessReviewed(proceso, user.email); }}
                      title={rev ? 'Marcar como pendiente' : 'Marcar como revisada'}
                    >
                      <span className={`scn9-check ${rev ? 'on' : ''}`}>{rev && <FiCheck />}</span>
                    </div>
                    <div className="scn9-c-conv">
                      <div className="scn9-conv-meta">
                        <button
                          type="button"
                          className="scn9-nom scn9-copy-nom"
                          title={proceso.nomenclatura ? `Copiar: ${proceso.nomenclatura}` : 'Sin nomenclatura'}
                          aria-label={`Copiar nomenclatura ${proceso.nomenclatura || ''}`}
                          disabled={!proceso.nomenclatura}
                          onClick={async () => {
                            try {
                              await navigator.clipboard.writeText(proceso.nomenclatura);
                              showToast('Nomenclatura copiada', 'success');
                            } catch {
                              showToast('No se pudo copiar la nomenclatura. Inténtalo nuevamente.', 'error');
                            }
                          }}
                        >
                          <span>{proceso.nomenclatura || '—'}</span>
                          <FiCopy aria-hidden="true" />
                        </button>
                        {rev ? (
                          <span className="scn9-revtag"><FiCheck /> Revisada</span>
                        ) : (
                          <>
                            <span className="scn9-items">{proceso.total_items} ítem{proceso.total_items !== 1 ? 's' : ''}</span>
                            {proceso.tipo_proceso && <span className="scn9-proc">{proceso.tipo_proceso}</span>}
                          </>
                        )}
                      </div>
                      <div
                        className="scn9-conv-desc"
                        onClick={() => abrirPanel(globalIndex)}
                        onMouseEnter={(e) => handleMouseEnterDescription(e, proceso.descripcion_proceso)}
                        onMouseLeave={handleMouseLeaveDescription}
                      >
                        {proceso.descripcion_proceso || 'Sin descripción'}
                      </div>
                    </div>
                    <div className="scn9-c-ent">
                      <div className="scn9-ent-name">{proceso.entidad || '—'}</div>
                      <div className="scn9-ent-loc">{[proceso.departamento, proceso.provincia, proceso.distrito].filter(Boolean).join(' · ') || '—'}</div>
                    </div>
                    <div className="scn9-c-tipo">
                      <span className="scn9-tag" style={{ color: oc.color, background: oc.bg, borderColor: oc.border }}>
                        <span className="scn9-dot" style={{ background: oc.dot }} />
                        {proceso.objet || 'N/A'}
                      </span>
                    </div>
                    <div className="scn9-c-cierra">
                      <div className="scn9-cierra-days" style={{ color: cb.color }}>{cb.label}</div>
                      <div className="scn9-cierra-date">{fechaCorta(proceso.fecha_fin_participantes)}</div>
                    </div>
                    <div className="scn9-c-acc">
                      <button className={`scn9-verbtn ${rev ? 'outline' : ''}`} onClick={() => abrirPanel(globalIndex)}>Ver detalle</button>
                      <BotonDocumentos
                        proceso={proceso}
                        onAbrir={openBases}
                        className="scn9-icobtn"
                        titulo="Bases y anexos"
                      />
                      {codigosEnCalendario.has(proceso.nomenclatura) ? (
                        <button
                          className="scn9-icobtn is-added"
                          title="En tu calendario · clic para quitarlo"
                          aria-label="Quitar del calendario"
                          disabled={calOcupado === proceso.nomenclatura}
                          onClick={() => alternarCalendario(proceso)}
                        >
                          <CalendarCheck size={17} aria-hidden="true" className="scn9-cal-on" />
                          <CalendarX size={17} aria-hidden="true" className="scn9-cal-off" />
                        </button>
                      ) : (
                        <button
                          className="scn9-icobtn"
                          title="Añadir al calendario"
                          aria-label="Añadir al calendario"
                          disabled={calOcupado === proceso.nomenclatura}
                          onClick={() => alternarCalendario(proceso)}
                        >
                          <FiCalendar />
                        </button>
                      )}
                      <button
                        type="button"
                        className="scn9-icobtn scn9-whatsapp"
                        title="Compartir por WhatsApp"
                        aria-label="Compartir convocatoria por WhatsApp"
                        onClick={() => compartirWhatsApp(proceso)}
                      >
                        <FaWhatsapp aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                );
              })}

              <div className="scn9-list-foot">
                <PaginationComponent />
              </div>
            </div>
          </div>

          {/* Modal de detalle */}
          {procesoPanel && (() => {
            const revisado = isProcessReviewed(procesoPanel);
            const oc = objetoColor(procesoPanel.objet);
            const cb = cierreBadge(procesoPanel);
            const cuenta = cuentaRegresiva(procesoPanel.fecha_fin_participantes);
            const enCurso = registroEnCurso(procesoPanel);
            const ventana = ventanaRegistro(procesoPanel);
            const hayDoc = procesoPanel.url_doc && procesoPanel.url_doc.trim() !== '';
            const contexto = filtroEstadoRevision === 'pendientes'
              ? 'Solo pendientes' : filtroEstadoRevision === 'revisados' ? 'Solo revisadas' : null;
            const horaCierre = fechaHora(procesoPanel.fecha_fin_participantes).split('·')[1]?.trim();
            return (
            <div className="scn9-modal-overlay" onClick={cerrarPanel}>
              <div className="scn9-modal" onClick={(e) => e.stopPropagation()}>
                <div className="scn9-panel-head">
                  <span className="scn9-panel-title">
                    Convocatoria {panelIndex + 1} de {dataFiltrada.length}
                    {contexto && <span className="scn9-panel-sub"> · {contexto}</span>}
                  </span>
                  <div className="scn9-panel-nav">
                    <button className="scn9-navbtn" title="Anterior (K)" onClick={() => panelNav(-1)} disabled={panelIndex <= 0}><FiChevronLeft /> Anterior</button>
                    <button className="scn9-navbtn" title="Siguiente (J)" onClick={() => panelNav(1)} disabled={panelIndex >= dataFiltrada.length - 1}>Siguiente <FiChevronRight /></button>
                  </div>
                  <button className="scn9-panel-ic" title="Cerrar (Esc)" onClick={cerrarPanel}><FiX /></button>
                </div>
                <div className="scn9-modal-body">
                  <div className="scn9-modal-heading">
                    <div className="scn9-panel-tags">
                      <span className="scn9-tag" style={{ color: oc.color, background: oc.bg, borderColor: oc.border }}>
                        <span className="scn9-dot" style={{ background: oc.dot }} />
                        {procesoPanel.objet || 'N/A'}
                      </span>
                      {procesoPanel.tipo_proceso && <span className="scn9-tag scn9-tag-soft">{procesoPanel.tipo_proceso}</span>}
                      <span className="scn9-tag scn9-tag-cierre" style={{ color: cb.color, background: cb.bg }}>
                        <FiClock />
                        <b>Cierra {cb.label.toLowerCase()}</b>
                        {horaCierre && <small>· {fechaCorta(procesoPanel.fecha_fin_participantes)}</small>}
                      </span>
                      <span className={`scn9-modal-status ${revisado ? 'is-on' : ''}`}>
                        {revisado ? <><FiCheck /> Revisada</> : 'Pendiente de revisión'}
                      </span>
                    </div>
                    <div className="scn9-panel-desc">{procesoPanel.descripcion_proceso || 'Sin descripción'}</div>
                    <div className="scn9-modal-code">
                      <span className="scn9-modal-code-txt">{procesoPanel.nomenclatura || '—'}</span>
                      <button
                        className="scn9-modal-code-copy"
                        onClick={() => { navigator.clipboard.writeText(procesoPanel.nomenclatura || ''); setCopiedModal('nom'); setTimeout(() => setCopiedModal(null), 1500); }}
                      >
                        {copiedModal === 'nom' ? <><FiCheck /> Copiado</> : <><FiCopy /> Copiar código</>}
                      </button>
                    </div>
                  </div>

                  <div className="scn9-modal-cols">
                    <div className="scn9-modal-main">
                      <div className="scn9-panel-section">DATOS DE LA CONVOCATORIA</div>
                      <div className="scn9-panel-grid">
                        <div><label>ENTIDAD</label><span>{procesoPanel.entidad || '—'}</span></div>
                        <div><label>UBICACIÓN</label><span>{[procesoPanel.departamento, procesoPanel.provincia, procesoPanel.distrito].filter(Boolean).join(' · ') || '—'}</span></div>
                        <div><label>PROCEDIMIENTO</label><span>{procesoPanel.tipo_proceso || '—'}</span></div>
                        <div><label>MONEDA</label><span>{procesoPanel.moneda || '—'}</span></div>
                        {procesoPanel.num_proceso && (
                          <div><label>N.º DE PROCESO</label><span>{procesoPanel.num_proceso}</span></div>
                        )}
                      </div>

                      {procesoPanel.items && procesoPanel.items.length > 0 && (
                        <>
                          <div className="scn9-panel-section">ÍTEMS DEL REQUERIMIENTO <b>{procesoPanel.total_items}</b></div>
                          <div className="scn9-panel-items">
                            {procesoPanel.items.slice(0, 12).map((it, i) => (
                              <div className="scn9-panel-item" key={i}>
                                <span className="scn9-panel-item-idx">{i + 1}</span>
                                <div className="scn9-panel-item-body">
                                  <div className="scn9-panel-item-txt">{it.detalle_item || '—'}</div>
                                  <div className="scn9-panel-item-sub">
                                    {it.detCubso && <span>CUBSO {it.detCubso}</span>}
                                    {it.cantItem && <span>· {it.cantItem} {it.detUnidadMedida || 'und'}</span>}
                                  </div>
                                </div>
                              </div>
                            ))}
                            {procesoPanel.items.length > 12 && <div className="scn9-panel-item-more">+{procesoPanel.items.length - 12} ítems más</div>}
                          </div>
                        </>
                      )}

                      <div className="scn9-panel-section">DOCUMENTOS</div>
                      {hayDoc ? (
                        <button className="scn9-doc" onClick={() => openBases(procesoPanel.url_doc)}>
                          <span className="scn9-doc-ic"><FaFilePdf size={19} aria-hidden="true" /></span>
                          <div className="scn9-doc-main">
                            <div className="scn9-doc-title">Bases</div>
                            <div className="scn9-doc-sub">PDF · se abre en una pestaña nueva</div>
                          </div>
                          <FiExternalLink className="scn9-doc-ext" />
                        </button>
                      ) : (
                        <div className="scn9-doc scn9-doc-empty">Sin documento disponible</div>
                      )}
                      {/* Anexos de la entidad (columna `url_anexos`). No hay
                          estado vacío: casi ninguna convocatoria los trae. */}
                      <AnexosConvocatoria
                        texto={procesoPanel.url_anexos}
                        prefijo="scn9"
                        onAbrir={openBases}
                      />
                    </div>

                    <div className="scn9-modal-side">
                      <div className="scn9-crono-head">
                        <span className="scn9-panel-section">CRONOGRAMA</span>
                        {cuenta && <span className={`scn9-crono-count ${cuenta.urgente ? 'is-urgent' : ''}`}><FiClock /> {cuenta.label}</span>}
                      </div>
                      <div className="scn9-crono">
                        {renderCronoRow('Convocatoria', procesoPanel.fecha_convocatoria, '#cbd5e1')}
                        {renderCronoRow('Inicio de registro', procesoPanel.fecha_inicio_participantes, '#0f766e', enCurso)}
                        {renderCronoRow('Fin de registro', procesoPanel.fecha_fin_participantes, '#b42318')}
                        {renderCronoRow('Presentación de propuestas', procesoPanel.fecha_presentacion_propuestas, '#a86a12')}
                        {ventana && (
                          <div className="scn9-crono-window">
                            <div className="scn9-crono-window-top">
                              <span>Ventana de registro</span>
                              <b>día {ventana.diaActual} de {ventana.totalDias}</b>
                            </div>
                            <div className="scn9-crono-window-bar">
                              <span style={{ width: `${Math.max(2, ventana.pct)}%` }} />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="scn9-panel-section">SEGUIMIENTO</div>
                      <div className="scn9-seg">
                        {codigosEnCalendario.has(procesoPanel.nomenclatura) ? (
                          <button
                            className="scn9-seg-btn is-added"
                            disabled={calOcupado === procesoPanel.nomenclatura}
                            onClick={() => alternarCalendario(procesoPanel)}
                          >
                            <span className="scn9-seg-ic teal"><CalendarCheck size={16} aria-hidden="true" /></span>
                            <span className="scn9-seg-txt">
                              <b>Ya está en tu calendario</b>
                              <small>Clic para quitarlo</small>
                            </span>
                          </button>
                        ) : (
                          <button
                            className="scn9-seg-btn"
                            disabled={calOcupado === procesoPanel.nomenclatura}
                            onClick={() => alternarCalendario(procesoPanel)}
                          >
                            <span className="scn9-seg-ic teal"><FiCalendar /></span>
                            <span className="scn9-seg-txt">
                              <b>Añadir al calendario</b>
                              <small>Crea recordatorios de los hitos</small>
                            </span>
                          </button>
                        )}
                        <button className="scn9-seg-btn" onClick={() => generarOferta(procesoPanel)}>
                          <span className="scn9-seg-ic blue"><FiFilePlus /></span>
                          <span className="scn9-seg-txt">
                            <b>Generar oferta</b>
                            <small>Abre el asistente con estos datos</small>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="scn9-modal-foot">
                  <span className="scn9-modal-kbd"><FiCornerDownRight /> <b>J / K</b> recorre la lista · <b>E</b> revisa y avanza · <b>Esc</b> cierra</span>
                  <div className="scn9-modal-foot-actions">
                    <button
                      type="button"
                      className="scn9-foot-primary scn9-modal-whatsapp"
                      onClick={() => compartirWhatsApp(procesoPanel)}
                    >
                      <FaWhatsapp aria-hidden="true" /> Compartir por WhatsApp
                    </button>
                    <button className="scn9-panel-sec" onClick={marcarYSiguiente}>
                      <span className={`scn9-check sm ${revisado ? 'on' : ''}`}>{revisado && <FiCheck />}</span>
                      {revisado ? 'Siguiente' : 'Marcar como revisada'}
                    </button>
                    <button className="scn9-foot-primary" disabled={!hayDoc} onClick={() => openBases(procesoPanel.url_doc)}>
                      <FiExternalLink /> Abrir Bases
                    </button>
                  </div>
                </div>
              </div>
            </div>
            );
          })()}
        </>
      )}
    </div>
  );
};

export default SEACENuevos;
